import React from 'react';

import Placeholder from 'components/consumer/Placeholder';

const PDPAddToBagSectionPlaceholder = () => (
  <div className="!mt-8">
    <Placeholder type="rect" loading className="!w-full !h-[44px]" />
    <Placeholder type="rect" loading className="!w-full !h-[12px] !mt-5" />
  </div>
);

export default PDPAddToBagSectionPlaceholder;
